"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UnitOfWorkIdGenerator_1 = require("./UnitOfWorkIdGenerator");
var Events_1 = require("../Events");
var UnitOfWork = /** @class */ (function (_super) {
    __extends(UnitOfWork, _super);
    /**
     * @param {Committable} committable it is often StoreGroup
     */
    function UnitOfWork(committable) {
        var _this = _super.call(this) || this;
        _this.id = UnitOfWorkIdGenerator_1.generateNewId();
        _this.commitments = [];
        _this.committable = committable;
        _this.isDisposed = false;
        return _this;
    }
    Object.defineProperty(UnitOfWork.prototype, "size", {
        get: function () {
            return this.commitments.length;
        },
        enumerable: true,
        configurable: true
    });
    UnitOfWork.prototype.addCommitment = function (commitment) {
        this.commitments.push(commitment);
        this.emit(commitment);
    };
    UnitOfWork.prototype.onAddedCommitment = function (handler) {
        return this.addEventListener(handler);
    };
    UnitOfWork.prototype.commit = function () {
        var _this = this;
        if (this.isDisposed) {
            throw new Error("already closed this transaction");
        }
        this.commitments.forEach(function (commitment) {
            _this.committable.commit(commitment);
        });
        this.prune();
    };
    UnitOfWork.prototype.prune = function () {
        this.commitments.length = 0;
    };
    UnitOfWork.prototype.release = function () {
        this.commitments.length = 0;
        this.isDisposed = true;
        this.removeAllEventListeners();
    };
    return UnitOfWork;
}(Events_1.Events));
exports.UnitOfWork = UnitOfWork;
//# sourceMappingURL=UnitOfWork.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/almin/lib/src/UnitOfWork/UnitOfWork.js
// module id = 481
// module chunks = 0